var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.4,
    height: 380.05,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.017143,
    y1: 0.982857,
    id: "gradient0",
    spreadMethod: "pad",
    x2: 0.370714,
    x1: 0.629286
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.017143,
    y1: 0.982857,
    id: "gradient1",
    spreadMethod: "pad",
    x2: 0.370714,
    x1: 0.629286
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0000",
    offset: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient2",
    gradientTransform: "matrix(0.03472900390625 0 0 0.03472900390625 10.3 116.8)",
    spreadMethod: "pad",
    cy: 0,
    cx: 0,
    r: 819.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 382.05,
    width: 91.4,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m44,19.250008l-0.25,0q-3.599998,0 -6.199997,-2.600006q-2.550003,-2.549988 -2.550003,-6.149994q0,-3.600008 2.550003,-6.199999q2.599998,-2.550003 6.199997,-2.550003q3.599998,0 6.150002,2.550003q2.599998,2.599991 2.599998,6.199999q0,3.600006 -2.599998,6.149994q-2.450001,2.5 -5.900002,2.600006",
    fill: "url(#gradient0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m44,19.250008l0,243.149986",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m59.75,189.699997l0,1.050003q-0.349998,5.899994 -4.650002,10.199997q-4.599998,4.600006 -11.099998,4.650009l-0.150002,0q-6.599998,0 -11.25,-4.650009q-4.299999,-4.300003 -4.599998,-10.199997l-0.049999,-1.050003q0,-6.599991 4.649998,-11.25q4.650002,-4.649994 11.25,-4.649994l0.150002,0q6.5,0.050003 11.099998,4.649994q4.650002,4.650009 4.650002,11.25",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.05,
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m44,262.399994l0,50.050018",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.05,
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m55.099998,178.449997q-4.599998,-4.599991 -11.099998,-4.649994l-0.150002,0q-6.599998,0 -11.25,4.649994q-4.649998,4.650009 -4.649998,11.25l0.049999,1.050003q0.299999,5.899994 4.599998,10.199997q4.650002,4.650009 11.25,4.650009l0.150002,0q6.5,-0.050003 11.099998,-4.650009q4.300003,-4.300003 4.650002,-10.199997l0,-1.050003q0,-6.599991 -4.650002,-11.25m9.650002,-10.649994q8.699997,8.649994 8.699997,21l-0.049995,1.949997q-0.650002,11.050003 -8.650002,19.050003q-8.599998,8.599991 -20.75,8.699997l-0.25,0q-12.35,0 -21.049999,-8.699997q-8,-8 -8.650002,-19.050003l0,-1.949997q-0.049999,-12.350006 8.650002,-21q8.699999,-8.699997 21.049999,-8.699997l0.25,0q12.150002,0.099991 20.75,8.699997",
    fillOpacity: 0.2,
    fill: "#3399ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    d: "m55.099998,178.449997q4.650002,4.650009 4.650002,11.25l0,1.050003q-0.349998,5.899994 -4.650002,10.199997q-4.599998,4.600006 -11.099998,4.650009l-0.150002,0q-6.599998,0 -11.25,-4.650009q-4.299999,-4.300003 -4.599998,-10.199997l-0.049999,-1.050003q0,-6.599991 4.649998,-11.25q4.650002,-4.649994 11.25,-4.649994l0.150002,0q6.5,0.050003 11.099998,4.649994m-11.099998,83.949997l0,50.050018",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.05,
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m44,19.250008l0,99.849998",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    d: "m44,19.250008l-0.25,0q-3.599998,0 -6.199997,-2.600006q-2.550003,-2.549988 -2.550003,-6.149994q0,-3.600008 2.550003,-6.199999q2.599998,-2.550003 6.199997,-2.550003q3.599998,0 6.150002,2.550003q2.599998,2.599991 2.599998,6.199999q0,3.600006 -2.599998,6.149994q-2.450001,2.5 -5.900002,2.600006",
    fill: "url(#gradient1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    d: "m44,19.250008l-0.25,0q-3.599998,0 -6.199997,-2.600006q-2.550003,-2.549988 -2.550003,-6.149994q0,-3.600008 2.550003,-6.199999q2.599998,-2.550003 6.199997,-2.550003q3.599998,0 6.150002,2.550003q2.599998,2.599991 2.599998,6.199999q0,3.600006 -2.599998,6.149994q-2.450001,2.5 -5.900002,2.600006",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#333333",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    d: "m47,314.600006q0,-1.25 -0.900002,-2.149994q-0.899998,-0.900024 -2.099998,-0.850006q-1.25,-0.050018 -2.150002,0.850006q-0.899998,0.899994 -0.849998,2.149994q-0.049999,1.199982 0.849998,2.100006q0.900002,0.899994 2.150002,0.899994q1.200001,0 2.099998,-0.899994q0.900002,-0.900024 0.900002,-2.100006m12.599998,-0.050018q0,6.550018 -4.599998,11.150024q-4.599998,4.599976 -11.100002,4.599976q-6.549995,0 -11.149998,-4.599976q-4.6,-4.600006 -4.6,-11.150024q0,-6.549988 4.6,-11.149994q4.600002,-4.600006 11.149998,-4.549988q6.500004,-0.050018 11.100002,4.549988q4.599998,4.600006 4.599998,11.149994",
    fill: "url(#gradient2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    d: "m47,314.600006q0,1.199982 -0.900002,2.100006q-0.899998,0.899994 -2.099998,0.899994q-1.25,0 -2.150002,-0.899994q-0.899998,-0.900024 -0.849998,-2.100006q-0.049999,-1.25 0.849998,-2.149994q0.900002,-0.900024 2.150002,-0.850006q1.200001,-0.050018 2.099998,0.850006q0.900002,0.899994 0.900002,2.149994m12.599998,-0.050018q0,6.550018 -4.599998,11.150024q-4.599998,4.599976 -11.100002,4.599976q-6.549995,0 -11.149998,-4.599976q-4.6,-4.600006 -4.6,-11.150024q0,-6.549988 4.6,-11.149994q4.600002,-4.600006 11.149998,-4.549988q6.500004,-0.050018 11.100002,4.549988q4.599998,4.600006 4.599998,11.149994",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.05,
    stroke: "#666666",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.e1175c8d9b49ca31c69f4ba1cdc57645.svg";
export { ForwardRef as ReactComponent };